import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import { returnSubmit } from "../../../../enums/queryFunction/Submit";
import { ABOUT_US } from "../../../../enums/QueryKeys";
import { HttpStatusCode } from "axios";
import logger from "../../../../utils/logger";
import { snackbarSeverity } from "../../../../hooks/useSnackbar";

// submit() rethrows the backend response body, which is normally a translation
// key string - but can be an object (e.g. Spring's default error JSON) or empty.
// Anything that isn't a usable string falls back to the generic error message.
function getErrorMessage(error) {
  if (typeof error === "string" && error.trim()) return error;
  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }
  return "SomethingWentWrong";
}

export default function usePutClinic(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const queryKey = key;

  const submitCallback = async (obj) => {
    setLoading(true);
    try {
      const response = await mutateAsync(obj);
      return response?.status === HttpStatusCode.Ok;
    } catch (error) {
      logger.error("Mutation failed:", error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  function updateKey() {
    queryClient.invalidateQueries([ABOUT_US]);
    queryClient.invalidateQueries([queryKey]);
  }

  const { mutateAsync } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: () => {
      updateKey();
      handleSnackbar("successMessage", snackbarSeverity.SUCCESS);
    },
    onError: (error) => {
      handleSnackbar(getErrorMessage(error), snackbarSeverity.ERROR);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
